define('views/pages/wishlist/offers/wishlist-results',['require','jquery','views/base/collection','./wishlist-result','text!templates/pages/wishlist/offers/wishlist-results.ejs'],function(require) {
    'use strict';

    var $ = require('jquery'),
        CollectionView = require('views/base/collection'),
        WishlistResultView = require('./wishlist-result'),
        template = require('text!templates/pages/wishlist/offers/wishlist-results.ejs');

    var WishlistResultsView = CollectionView.extend({
        autoRender: true,
        tagName: 'table',
        className: 'table table-bordered table-hover',
        region: 'wishlist-results',
        listSelector: 'tbody',
        fallbackSelector: '.empty',
        loadingSelector: 'tbody',
        template: template,
        itemView: WishlistResultView,

        toggleLoadingIndicator: function() {
            var visible = this.collection.length === 0 && this.collection.isSyncing();
            return this.$(this.loadingSelector)[visible ? 'addClass' : 'removeClass']('preloader');
        }
    });

    return WishlistResultsView;
});

